import { Card } from '@/components/ui/card';
import { Tag } from '@/components/common/Tag';
import type { BrightDataSnapshotRowDto } from '@/types/dto';

function formatAge(iso: string): string {
  const secs = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 1000));
  if (secs < 90) return `${secs}s ago`;
  const mins = Math.round(secs / 60);
  if (mins < 90) return `${mins}m ago`;
  const hrs = Math.round(mins / 60);
  return `${hrs}h ago`;
}

function statusVariant(status: string): 'tier-1' | 'tier-2' | 'tier-3' | 'neutral' {
  switch (status) {
    case 'completed': return 'tier-1';
    case 'pending': return 'tier-2';
    case 'failed': return 'tier-3';
    default: return 'neutral';
  }
}

export function QueueTable({ snapshots }: { snapshots: BrightDataSnapshotRowDto[] }) {
  return (
    <Card>
      <h2 className="text-xl font-semibold mb-3">Bright Data Snapshots (last 30 min)</h2>
      {snapshots.length === 0 ? (
        <p className="text-muted">Queue is quiet.</p>
      ) : (
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b-2 border-accent">
              <Th>Entity</Th><Th>Job</Th><Th>Status</Th><Th>Snapshot ID</Th><Th>Age</Th>
            </tr>
          </thead>
          <tbody>
            {snapshots.map((s) => (
              <tr key={s.snapshotId} className="border-b border-border">
                <td className="py-2 px-3">{s.entityName ?? '—'}</td>
                <td className="py-2 px-3 text-muted">{s.jobType}</td>
                <td className="py-2 px-3"><Tag variant={statusVariant(s.status)}>{s.status}</Tag></td>
                <td className="py-2 px-3 text-muted font-mono text-xs break-all">{s.snapshotId}</td>
                <td className="py-2 px-3 text-muted whitespace-nowrap">{formatAge(s.createdAt)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </Card>
  );
}

function Th({ children }: { children: React.ReactNode }) {
  return <th className="py-2 px-3 text-left text-[0.75rem] uppercase tracking-widest text-muted font-(family-name:--font-ui)">{children}</th>;
}
